/* eslint-disable array-callback-return */
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, Button, Collapse, Skeleton, useMediaQuery } from "@mui/material";
import { remove, uniqWith, isEqual } from "lodash";
import React, { Fragment, useEffect, useState, useTransition } from "react";
import AvailableFilter from "./active.jsx";
import CheckBoxFilter from "./checkBox.jsx";
import DateFilter from "./date.jsx";
import Enums from "./enum.jsx";
import QtyFilter from "./qty.jsx";
import TextFilter from "./text.jsx";
import ControlledFilters from "./controlled";
const Filters = ({
  headers,
  setFilter,
  filter,
  setPage,
  loading,
  limit,
  setLimit,
}) => {
  const [data, setData] = useState({});
  const [hasFilter, sethasFilter] = useState({});
  const [filters, setfilters] = useState(false);
  const [headLoad, setheadLoad] = useState(false);
  const [defualtLoaded, setdefualtLoaded] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [isPending, startTransition] = useTransition();
  const [defualt, setDefualt] = useState([]);
  const [sortedHeader, setsortedHeader] = useState([]);
  /*   const [pageType, setpageType] = useState(2);
  useLayoutEffect(() => {
    if (localStorage.getItem("pageType")) {
      setpageType(Number(localStorage.getItem("pageType")));
    }
  }, [localStorage.getItem("pageType")]); */
  useEffect(() => {
    var temp = [...headers];
    setsortedHeader(
      temp?.sort(
        (a, b) => parseFloat(a.filterOrder) - parseFloat(b.filterOrder)
      )
    );
  }, [headers]);
  const changeFilter = (value) => {
    startTransition(() => {
      var temp = [...defualt];
      temp.map((item) => {
        var findF = filter.find((fi) => fi.name === item.name);
        if (findF) {
          temp = temp.filter((it) => it.name !== findF.name);
        }
      });
      temp = [...temp, ...filter];
      var finded = false;
      if (value.isDate) {
        finded = temp.find(
          (all) => all.name === value.name && all.type === value.type
        );
        if (finded) {
          remove(temp, function (n) {
            return n.name === value.name && n.type === value.type;
          });
        }
      } else {
        finded = temp.find((all) => all.name === value.name);
        if (finded) {
          remove(temp, function (n) {
            return n.name === value.name;
          });
        }
      }

      temp.push(value);
      temp = temp.filter((filters) => filters.name !== "defaultFilter");

      setFilter(uniqWith(temp, isEqual));
      setPage(1);
      setData({ ...data, [value.name]: value.value });
    });
  };

  const resetFilter = () => {
    setData({});
    setFilter([
      {
        name: "defaultFilter",
        value: false,
        type: "eq",
      },
    ]);
    setRefresh((r) => r + 1);
  };
  useEffect(() => {
    var has = headers.find((item) => item.hasFilter);
    sethasFilter(has ? true : false);
    if (loading === false && headers.length > 0) {
      setheadLoad(true);
    }
  }, [headers]);
  const isDesktop = useMediaQuery("(min-width:900px)");
  const removeFilter = (item) => {
    var temp = [...filter];

    var n = temp.filter((filters) => filters.name !== item.name);

    n = n.filter((filters) => filters.name !== "defaultFilter");
    var d = { ...data };
    delete d[item.name];
    setData(d);

    if (n.length === 0) {
      setFilter([
        {
          name: "defaultFilter",
          value: false,
          type: "eq",
        },
      ]);
    } else {
      setFilter(n);
    }
    setPage(1);
  };
  useEffect(() => {
    if (!defualtLoaded && headers?.length > 0) {
      var temp = [];
      headers.map((item, index) => {
        if (item.defaultFilter) {
          temp.push({
            name: item.name,
            value: item.defaultFilter,
            type: "eq",
          });
        }
      });
      setdefualtLoaded(true);
      setDefualt(temp);
    }
  }, [headers]);

  const AllFilters = () => {
    return (
      <Box
        sx={{
          ".MuiInputBase-root": {
            maxWidth: { sm: "11.25rem !important" },
          },
          ".MuiFormControl-root": {
            maxWidth: { sm: "11.25rem !important" },
          },
          ".MuiFormLabel-root": {
            fontSize: { sm: "0.83rem !important" },
          },
        }}
        className="flex flex-wrap items-center gap-2"
      >
        {/*    {pageType === 2 ? (
          <div className="sm:w-[11.25rem] w-full">
            {" "}
            <Dropdown
              title={"تعداد نمایش"}
              data={[5, 10, 15, 20, 30]}
              value={limit}
              change={(e) => {
                setLimit(e);
              }}
            />
          </div>
        ) : (
          <></>
        )}
 */}
        {sortedHeader.map((item, index) => (
          <Fragment key={"allFilters" + item.name + index}>
            {item.hasFilter && (
              <>
                {item.type === "date" ? (
                  <DateFilter
                    refresh={refresh}
                    changeFilter={changeFilter}
                    item={item}
                  />
                ) : item.type === "enum" ? (
                  <div className="sm:w-[11.25rem] w-full">
                    <Enums
                      data={data}
                      changeFilter={changeFilter}
                      item={item}
                      removeFilter={() => removeFilter(item)}
                      refresh={refresh}
                    />
                  </div>
                ) : item.type === "string" ? (
                  <div className="sm:w-[11.25rem] w-full">
                    <TextFilter
                      refresh={refresh}
                      changeFilter={changeFilter}
                      item={item}
                    />
                  </div>
                ) : item.type === "available" ? (
                  <>
                    <AvailableFilter
                      refresh={refresh}
                      changeFilter={changeFilter}
                      item={item}
                      removeFilter={() => removeFilter(item)}
                    />
                  </>
                ) : item.type === "qty" ? (
                  <>
                    <QtyFilter
                      refresh={refresh}
                      changeFilter={changeFilter}
                      item={item}
                      removeFilter={() => removeFilter(item)}
                    />
                  </>
                ) : (
                  <>
                    <CheckBoxFilter
                      refresh={refresh}
                      changeFilter={changeFilter}
                      item={item}
                      removeFilter={() => removeFilter(item)}
                    />
                  </>
                )}
              </>
            )}
          </Fragment>
        ))}
        <div className="sm:w-auto w-full flex justify-end">
          {" "}
          <Button onClick={resetFilter} variant="contained" color="success">
            <RestartAltIcon />
            ریست فیلتر
          </Button>
        </div>
      </Box>
    );
  };
  return (
    <>
      {!headLoad && loading ? (
        <div className="flex flex-wrap gap-4">
          <Skeleton className="sm:w-[200px] w-full"></Skeleton>
          <Skeleton className="sm:w-[200px] w-full"></Skeleton>
          <Skeleton className="sm:w-[200px] w-full"></Skeleton>
        </div>
      ) : (
        <>
          {" "}
          {hasFilter ? (
            <>
              {isDesktop ? (
                <> {AllFilters()}</>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "100%",
                    }}
                    onClick={() => setfilters(!filters)}
                  >
                    <span className="text-xs">فیلتر ها</span>
                    <ArrowDropDownIcon
                      className="transition"
                      sx={{
                        color: "#8E8E8E",
                        transform: filters ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    />
                  </Box>

                  <Collapse sx={{ width: "100%" }} in={filters}>
                    <div className="flex flex-col gap-3 w-full pt-4 pb-2">
                      {AllFilters()}
                    </div>
                  </Collapse>
                </>
              )}
            </>
          ) : (
            <div></div>
          )}
        </>
      )}
    </>
  );
};

const MemoFilters = React.memo(Filters);
export default function TableFilters(props) {
  return props.schema ? <ControlledFilters {...props} /> : <MemoFilters {...props} />;
}
